module.exports = __webpack_public_path__ + "assets/adpoly-it-ip-phones-bulk-upload-template.87ac301b.xlsx";